import { ActivityState } from 'entities/lifecycle/activityState';
import { theme } from '@salecycle/ui-component-library';
import { TFunction } from 'react-i18next';

interface IConfig {
  text: string;
  color: string;
}

export const campaignActivityStatesConfig: (
  translator: TFunction<'campaigns'>,
) => { [type in ActivityState]: IConfig } = (translator: TFunction<'campaigns'>) => ({
  Live: {
    text: translator('activityStatus.live'),
    color: theme.vars.newColor.green2,
  },
  Paused: {
    text: translator('activityStatus.paused'),
    color: null,
  },
  Scheduled: {
    text: translator('activityStatus.scheduled'),
    color: theme.vars.newColor.blue3,
  },
  Finished: {
    text: translator('activityStatus.finished'),
    color: theme.vars.newColor.purple2,
  },
  Archived: {
    text: translator('activityStatus.archived'),
    color: theme.vars.newColor.darkGS2,
  },
  Testing: {
    text: translator('activityStatus.testing'),
    color: theme.vars.newColor.orange1,
  },
  Migration: {
    text: translator('activityStatus.migration'),
    color: theme.vars.newColor.blue1,
  },
});
